import IconArrowRight from "@/app/(site)/_components/Atoms/Icons/IconArrowRight"
import Text from "../../../Atoms/Text"
import ButtonText from "../../../Molecules/ButtonText"
import DynamicLink from "../../../Molecules/Link"

type LinksContentCardProps = {
    title: string
    links: {
        title: string
        isNavigationContainer?: boolean
        slug?: string
        url?: string
    }[]
}

export default function LinksContentCard2({ title, links }: LinksContentCardProps) {
    return (
        <div>
            <div className="mb-24 hidden md:block">
                <Text size="medium" weight="light">
                    {title}
                </Text>
            </div>
            <ul className="flex flex-col gap-8">
                {links.map((link, index) => {
                    if (link.isNavigationContainer) return null
                    return (
                        <li key={index}>
                            <DynamicLink
                                href={link?.slug || (link?.url ?? "")}
                                prefetch={false}
                            >
                                <ButtonText
                                    className="flex items-center gap-8 text-start !text-12 !uppercase md:!text-16"
                                    iconPosition="right"
                                    size="big"
                                    icon={
                                        <IconArrowRight className="h-20 w-20 shrink-0" />
                                    }
                                >
                                    <div className="!text-12 md:!text-16">
                                        {link.title}
                                    </div>
                                </ButtonText>
                            </DynamicLink>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
